import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "none",
	viewBox: "0 0 32 32",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 13.5,
		cy: 13.5,
		r: 8.5,
		stroke: "black",
		strokeWidth: 3
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "black",
		strokeLinecap: "round",
		strokeWidth: 3,
		d: "M20 20L27 27"
	})]
});
const ForwardRef = forwardRef(SvgSearch);
export default ForwardRef;
